module.exports = __webpack_public_path__ + "static/img/banner___.1bd2382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner___.png
// module id = yXvp
// module chunks = 1